import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { FallingLines } from "react-loader-spinner";
import LabelForm from "pages/signup/form/labelForm";
import BGShutterstock from "images/auth/bg-shutterstock.png";
import { ReactComponent as TVendorIcon } from "images/auth/t-vendors.svg";
import useInviteAssignees from "./useInviteAssignees";
import { ReactComponent as ApprovedImage } from "images/externalPage/high-five.svg";
import { ReactComponent as DeclineImage } from "images/externalPage/decline-image.svg";
import InvitationStep from "./components/InvitationStep";
import PoDetailsStep from "./components/PoDetailsStep";

const InviteAssignees = () => {
  const [t] = useTranslation();

  const Loading = () => {
    return (
      <div className="flex items-center justify-center h-screen w-full">
        <FallingLines
          color="#023A66"
          width="100%"
          visible={true}
          ariaLabel="falling-lines-loading"
        />
      </div>
    );
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const {
    navigate,
    slug,
    // shared state
    isLoading,
    emailParam,
    successMsg,
    isAccept,
    onInviteAssignee,
    onPoDecision,
    orderStatusValidation,
    poDetailsLoading,
    poDetails,
    isZeroTotal
  } = useInviteAssignees();

  const handleInviteAction = (accept) => {
    return (data) => {
      onInviteAssignee(data, accept);
    };
  };

  useEffect(() => {
    orderStatusValidation();
  }, []);

  if (!isLoading.statusCheck) {
    return <Loading />;
  } else {
    return (
      <form onSubmit={handleSubmit(handleInviteAction(true))}>
        <div
          className="w-full h-[100px] bg-no-repeat  bg-cover bg-center flex items-center px-[20%] xl-max:px-[10%] lg-max:px-[2rem] md-max:px-[1rem] fixed z-[999999999]"
          style={{
            backgroundImage: `url(${BGShutterstock})`,
            zIndex: 100,
          }}
        >
          <div className="max-w-[843px] w-full flex items-center justify-between">
            <TVendorIcon
              onClick={() => navigate("/login")}
              className="cursor-pointer"
            />
          </div>
        </div>
        {!successMsg && !isZeroTotal ? (
          slug === "poDetails" ? (
            !poDetails || poDetailsLoading ? (
              <Loading />
            ) : (
              <PoDetailsStep
                poDetails={poDetails}
                isLoading={isLoading}
                onAccept={() => onPoDecision(true)}
                onReject={() => onPoDecision(false)}
              />
            )
          ) : (
            <InvitationStep
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              onAccept={(data) => onInviteAssignee(data, true)}
              onReject={(data) => onInviteAssignee(data, false)}
              isLoading={isLoading}
              emailParam={emailParam}
            />
          )
        ) : (
          <div className="mt-[220px] px-[10%] xl-max:px-[10%] lg-max:px-[2rem] md-max:px-[1rem] flex flex-col mb-[97px] relative min-h-[calc(100vh-750px)] items-center justify-center">
            {isAccept ? <ApprovedImage /> : <DeclineImage />}
            <LabelForm
              label={t(successMsg)}
              labelClassName="text-primary font-bold text-[22px] md-max:text-[18px] not-italic ml-[15px]"
            />
          </div>
        )}
      </form>
    );
  }
};

export default InviteAssignees;
